export default "__VITE_ASSET__BgBcIbDG__"